export default (sectionId, childId, requestBody) =>
  new Promise((resolve, reject) => {
    window.axios
      .patch(`${process.env.VUE_APP_API_ADMIN_LOCATION}homefeed/section/${sectionId}/children/${childId}`, requestBody)
      .then(() => resolve())
      .catch((error) => {
        reject(error);
      });
  });
